module.exports = __webpack_public_path__ + "img/2.032d023a.png";